var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "__TEMP__SVG__",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 13.849,
    viewBox: "0 0 12.5 13.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M10.375,17.542h5.169a1.128,1.128,0,0,0,1.028-.844l1.716-4.883a1.62,1.62,0,0,0,.078-.5V9.918c0-.761-.511-1.609-1.136-1.609H13.648l.541-2.939.018-.216a1.16,1.16,0,0,0-.25-.732l-.607-.729L9.563,8.284a1.543,1.543,0,0,0-.33.977v6.924A1.259,1.259,0,0,0,10.375,17.542Z",
    transform: "translate(-5.866 -3.693)",
    fill: "#5e5e5e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M2.77,12.926H4.693V21H2.77Z",
    transform: "translate(-2.77 -7.155)",
    fill: "#5e5e5e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.b7fd3c5c2826f38f869fee30f2f8ffbb.svg";
export { ForwardRef as ReactComponent };